import React, { createContext, useState, useContext } from 'react';

// Create Context
const SidebarContext = createContext();

// Custom hook to use SidebarContext
export const useSidebar = () => {
    return useContext(SidebarContext);
};

// Provider Component
export const SidebarProvider = ({ children }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(true);

    // Submenu states
    const [isPaymentsOpen, setPaymentsOpen] = useState(false);
    const [isInventoryOpen, setInventoryOpen] = useState(false);
    const [isUserOpen, setUserOpen] = useState(false);
    const [isClassOpen, setClassOpen] = useState(false);
    const [isTeamOpen, setTeamOpen] = useState(false);
    const [isActivityOpen, setActivityOpen] = useState(false);

    // Function to toggle sidebar
    const toggleSidebar = () => setSidebarOpen((prevState) => !prevState);

    // Functions to toggle submenus
    const togglePayments = () => setPaymentsOpen((prevState) => !prevState);
    const toggleInventory = () => setInventoryOpen((prevState) => !prevState);
    const toggleUser = () => setUserOpen((prevState) => !prevState);
    const toggleClass = () => setClassOpen((prevState) => !prevState);
    const toggleTeam = () => setTeamOpen((prevState) => !prevState);
    const toggleActivity = () => setActivityOpen((prevState) => !prevState);

    return (
        <SidebarContext.Provider
            value={{
                isSidebarOpen,
                toggleSidebar,
                isPaymentsOpen,
                togglePayments,
                isInventoryOpen,
                toggleInventory,
                isUserOpen,
                toggleUser,
                isClassOpen,
                toggleClass,
                isTeamOpen,
                toggleTeam,
                isActivityOpen,
                toggleActivity
            }}
        >
            {children}
        </SidebarContext.Provider>
    );
};
